import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Tab, Tabs} from "react-bootstrap";
import {resetPage, showMessage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {showModal} from "../actions/modal";
import {countInvoices, loadInvoices, createInvoiceFromTrn} from '../actions/invoices';
import {loadTransactions} from '../actions/transactions'
import {setPageTitle} from "../utils";
import {defaultState} from "../reducers/paginate";
import InvoicesInfo from "../components/invoice/InvoicesInfo";

class Dashboard extends Component {

	constructor(props) {
		super(props);

		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleCreateInvoiceFromTrn = this.handleCreateInvoiceFromTrn.bind(this);
	}

	componentDidMount() {
		setPageTitle("Nástěnka");
	}

	// componentDidUpdate(prevProps) {
	// 	if (prevProps.match.params.invoiceId !== this.props.match.params.invoiceId
	// 		|| (prevProps.match.params.tab === 'detail' && this.props.match.params.tab !== 'detail')) {
	// 		this.props.loadInvoice(this.props.match.params.invoiceId);
	//
	// 	} else if (this.props.match.params.invoiceId) {
	// 		setPageTitle("Uživatel " + this.props.match.params.invoiceId);
	// 	}
	// }
	//
	componentWillUnmount() {
		this.props.resetPage();
		setPageTitle();
	}

	handleFetchData(filter) {
		this.props.loadInvoices(filter);

		const trnFilter = {
			partyIds: filter.partyIds,
			effDateFrom: filter.taxDateFrom || filter.paidDateFrom,
			effDateTo: filter.taxDateTo || filter.paidDateTo,
			isIncludeInvoiceDate: true,
			orderCol: 'effDate',
			orderDir: 'a'
		};
		this.props.loadTransactions(trnFilter);
	}

	handleCreateInvoiceFromTrn(trnId) {
		return this.props.createInvoiceFromTrn(trnId)
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleTabSelect(tab) {
		// setPageTitle(tab, "tab");
		this.props.history.push('/' + tab)
	}

	render() {
		const {match: {params}, invPage, trnPage, session, enums} = this.props;
		const tab = params.tab || 'all';

		const tabs = [];
		for (let i in session.user.parties) {
			if (!session.user.parties.hasOwnProperty(i)) {
				continue
			}
			const party = session.user.parties[i];
			tabs.push(<Tab key={party.partyId} eventKey={party.abbr} title={party.title} className="invoices-widget">
				{tab === party.abbr && <InvoicesInfo invPage={invPage} trnPage={trnPage} enums={enums} session={session}
					parties={[party]}
					match={this.props.match} history={this.props.history}
					onCreateInvoiceFromTrn={this.handleCreateInvoiceFromTrn}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>}
			</Tab>)
		}

		tabs.push(<Tab key={'all'} eventKey={'all'} title={'Vše'} className="invoices-widget">
			{tab === 'all' && <InvoicesInfo invPage={invPage} trnPage={trnPage} enums={enums} session={session}
				parties={session.user.parties}
				match={this.props.match} history={this.props.history}
				onCreateInvoiceFromTrn={this.handleCreateInvoiceFromTrn}
				onFetchEnums={this.handleFetchEnums}
				onFetchData={this.handleFetchData}
				onShowModal={this.props.showModal}
				onShowMessage={this.props.showMessage}
			/>}
		</Tab>);

		return (
			<div>
				<Tabs activeKey={tab} onSelect={this.handleTabSelect} transition={false} id="invoices-widget">
					{tabs}
				</Tabs>
			</div>
		)
	}
}

Dashboard.propTypes = {
	invPage: PropTypes.object,
	trnPage: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadInvoices: PropTypes.func.isRequired,
	countInvoices: PropTypes.func.isRequired,
	createInvoiceFromTrn: PropTypes.func.isRequired,
	loadTransactions: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {invoices, transactions},
		enums,
		session
	} = state;

	const invPage = invoices[0] || defaultState;
	const trnPage = transactions[0] || defaultState;

	return {
		invPage,
		trnPage,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadInvoices,
	loadTransactions,
	countInvoices,
	createInvoiceFromTrn,
	showMessage,
	resetPage,
	showModal
})(Dashboard)
